import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-330" data-mp="ry1clbsvi9ne">
      {eyebrow && <p className={`text-sm font-bold uppercase tracking-[0.18em] ${dark ? "text-cyan" : "text-cyan"}`} data-id="element-331" data-mp="rzu8px5v1bh5">{eyebrow}</p>}
      <h2 className={`mt-3 font-display text-[2rem] font-extrabold leading-[1.12] sm:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-332" data-mp="i87zu7gzvohk">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-lg leading-relaxed ${dark ? "text-white/80" : "text-muted"}`} data-id="element-333" data-mp="8a22m364v6j1">{subtitle}</p>}
    </div>;
}